var setToStringTag = require('../internals/set-to-string-tag');

// Math[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.math.to-string-tag.js
// module id = 453
// module chunks = 3